<template>
  <feeTable title="VIZBI Workshop" />
  <feeTable title="VIZBI Masterclass" />
  <RegisterNowWrapper />

  <!-- <router-link to="Registration/Form">
    <ButtonBespoke :outstanding="true" :disabled="false" onclick="openForm">
      Click here to open the registration form
    </ButtonBespoke></router-link
  > -->

  <h4>Group Discount for in-person attendance</h4>
  <p>
    Academic and Industry participants bringing colleagues and students can register as a group to
    receive a
    <strong>25% discount</strong>.
  </p>
  <h4>USC discount</h4>
  <p>
    University of Southern California 'Trojans' (affiliates, staff, and students) receive a discount
    on registration for these events. For USC staff, to take advantage of these discounts, you need
    to have an email address ending in 'usc.edu'. Use this email address when filling out the
    Registration Form, and in the discount code field enter: "VIZBI@USC".
    <strong>
      The discount rate for USC students is available to those who will present a poster. Please
      contact <a href="https://dornsife.usc.edu/profile/jona-cura/">Jona Cura</a> for the student
      discount codes.</strong
    >
  </p>
  <h4>ISCB discount</h4>
  <p>
    Members of the
    <a href="http://iscb.org/"> International Society for Computational Biology</a> (ISCB) receive a
    15% discount on registration for these events. We encourage participants to consider joining the
    ISCB to take advantage of these and
    <a href="http://www.iscb.org/iscb-membership">other benefits</a>.
  </p>
  <h4>DVS discount</h4>
  <p>
    General Members of the
    <a href="https://www.datavisualizationsociety.org/mission">Data Visualization Society</a> (DVS)
    receive a 15% discount on registration for these events. We encourage participants to consider
    joining the DVS to take advantage of these and
    <a href="https://www.datavisualizationsociety.org/membership">other benefits</a>. To take
    advantage of this discount, following the instructions on the
    <a href="https://www.datavisualizationsociety.org/discount-codes">DVS partners discount page</a>
    (only accessible to general members).
  </p>

  <h4>Terms and conditions</h4>
  <p>
    On-site registration fees include admission, event materials, meals and coffee breaks.
    Participants are expected to book and pay their own accommodation and travel expenses. For the
    online events, the registration fees include access to all of the talks (live-streamed and
    on-demand) and facility to submit questions.
  </p>

  <h4>Refund and cancellation policies</h4>
  <p>
    If you need to change or cancel your registration, send a written request to
    <Email to="vizbi-registration" />. Cancellation requests received prior to March 1 2024 will
    receive a 50% refund. After this date, no refund of fees will be made.
  </p>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import feeTable from "@/assets/years/2024/Registration/table.vue";
import RegisterNowWrapper from "@/components/CallToAction/RegisterNowWrapper";
// import ButtonBespoke from "@/components/ButtonBespoke";
// function openForm() {
//   if (typeof this.$fbq === "function") {
//     // Send custom conversion event to Facebook
//     this.$fbq("track", "Conversion", {
//       content_name: "Sign Up",
//       value: 1.0,
//       currency: "USD"
//     });
//   }
//   window.location.href = "Registration/Form";
// }
import Email from "@/components/Email.vue";
</script>

<style scoped>
h4 {
  margin-bottom: 0px;
}
.submit:active {
  position: relative;
  top: 1px;
}

button {
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 15px;
}

button[disabled] {
  /* pointer-events: none; disabled cause it hides title */
  cursor: default;
  color: #929292;
  background-color: #f5f3f7;
  border: 1px solid rgba(60, 60, 60, 0.2);
}
</style>
